import {billService} from "@/common/api.service"

const initialStates = {
    status: 'loading',
    psp: 'PASARGAD',
    corporates: null,
    active_collective_gateways: null,
    corporate_details: null,
}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    setPsp(state, psp) {
        state.status = 'setPsp'
        state.psp = psp
    },
    successGetCorporates(state, data) {
        state.corporates = data
    },
    successGetActiveCollectiveGateways(state, data) {
        state.active_collective_gateways = data
    },
}

const getters = {
    status: ({status}) => status,
    psp: ({psp}) => psp,
    corporates: ({corporates}) => corporates,
    active_collective_gateways: ({active_collective_gateways}) => active_collective_gateways,
}

const actions = {
    getCorporates({commit},query) {
        return billService.getCorporates(query).then(response => {
            commit('successGetCorporates', response.data.data)
        })
    },
    getActiveCollectiveGateways({commit}) {
        return billService.getActiveCollectiveGateways().then(response => {
            commit('successGetActiveCollectiveGateways', response.data.data)
        })
    },
    findCorporate({commit},query) {
        return billService.getCorporates(query).then(response => {
            commit('successGetCorporates', response.data.data)
        })
    },
}


export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}